import { PROCESS } from "@/data/content";

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="py-24 lg:py-32 bg-white border-t border-slate-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <span className="overline text-[#B91C1C]">How we work</span>
          <h2 className="mt-4 font-serif-display text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
            A precise, auditable workflow
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-5 border-t border-l border-slate-200">
          {PROCESS.map((step) => (
            <div key={step.no} data-testid={`process-step-${step.no}`} className="border-r border-b border-slate-200 p-8 lg:p-10">
              <span className="font-mono-plex text-sm text-[#B91C1C]">{step.no}</span>
              <h3 className="mt-4 font-serif-display text-xl font-semibold text-slate-900">{step.title}</h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
